import { useMemo, useRef } from "react";
import {
  serializeScriptSelectionsScripKey,
  scriptDropdownValuesFromSelections,
  serializeOrderInputKey,
} from "../pages/OrderInitiatePage/selectionUtils";

export function useOrderInitiateScriptKeys(scriptSelections) {
  const scriptSelectionsKey = useMemo(
    () => serializeScriptSelectionsScripKey(scriptSelections),
    [scriptSelections]
  );

  const scriptDropdownValues = useMemo(
    () => scriptDropdownValuesFromSelections(scriptSelections),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [scriptSelectionsKey]
  );

  const scriptDropdownValuesRef = useRef(scriptDropdownValues);
  scriptDropdownValuesRef.current = scriptDropdownValues;

  const orderInputKey = useMemo(() => serializeOrderInputKey(scriptSelections), [scriptSelections]);

  return {
    scriptSelectionsKey,
    scriptDropdownValues,
    scriptDropdownValuesRef,
    orderInputKey,
  };
}
